export const DEFAULT_FONT = {
  family: 'sans-serif',
  name: 'Sans Serif',
  size: 14,
}

export const STYLE_ID = 'editor-base-font'
